import { SubscriptionDataT } from "@anydo/interfaces";
import { makePostRequest } from "./makePostRequest";

export async function fetchSyncHttpPremiumStripeSubscribe(
  authToken: string | null,
  planId: string,
  stripeData: { setupIntentId: string },
  signal?: AbortSignal,
): Promise<{
  subscriptionData: SubscriptionDataT;
}> {
  const body = {
    stripe_plan: planId,
    stripe_data: stripeData,
  };

  const resp = await makePostRequest({
    requestName: "fetchSyncHttpPremiumStripeSubscribe",
    authToken,
    path: `/api/v1/subscribe_user/stripe`,
    body,
    signal,
  });

  return (await resp.json()) as {
    subscriptionData: SubscriptionDataT;
  };
}
